import React from "react";
import { Layout, theme } from "antd";
import ProfileDropdown from "../components/ProfileDropdown";
const { Header } = Layout;

const Desktopheader = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Header
      style={{
        borderRadius: "8px",
        margin: "24px 16px 16px 16px",
        padding: "8px",
        background: colorBgContainer,
      }}
      className={`flex justify-end items-center mediumShadow`}
    >
      <ProfileDropdown />
    </Header>
  );
};

export default Desktopheader;
